import {AfterViewInit, Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FormBuilder, Validators} from "@angular/forms";
import {sitToken} from '../../lib/models/sitToken';
import {AuthenticationService} from '../../lib/services/autenticacion/authentication.service';
import {TokenUnlockService} from "../../lib/services/token-unlock/token-unlock.service";
import {
    TokenCancelAuthorizationService
} from "../../lib/services/token-cancel-authorization/token-cancel-authorization.service";
import {StorageKeysEnum} from "../../lib/storage/storage-keys.enum";
import {UserUtilsService} from '../../lib/services/user/user-utils.service';
import {firstValueFrom} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';
import * as jwt from "jose";
import {Router} from "@angular/router";
import {SyncTokenService} from "../../lib/services/autenticacion/sync-token.service";

@Component({
    selector: 'lib-login-token',
    templateUrl: './login-token.component.html',
    styleUrls: ['./login-token.component.scss']
})
export class LoginTokenComponent implements OnInit, AfterViewInit {
    showLoginError = false;
    showSyncError = false;
    loginTokenForm: any;
    syncTokenForm: any;
    loading: boolean = false;
    queryLoading: boolean = false;
    queryError: boolean = false;
    showValidateError: boolean = false;
    requiereSiguiente: boolean = false;
    accessToken: any
    translations: any
    showChangePasswordModal = false
    showSyncToken = false;
    loadingSynchronizing = false

    @Output() onValidateTokenSuccess: EventEmitter<any> = new EventEmitter<any>();
    @Output() onLogout: EventEmitter<any> = new EventEmitter<any>();

    secret: string = "";
    fullName: string = "";
    sitTokenValue!: sitToken;
    notificationsSeen = sessionStorage.getItem('notificationSeen');

    constructor(
        private formBuilder: FormBuilder,
        private authenticationService: AuthenticationService,
        public tokenUnlockService: TokenUnlockService,
        public tokenCancelAuthorizationService: TokenCancelAuthorizationService,
        private userUtilsService: UserUtilsService,
        private translate: TranslateService,
        private router: Router,
        private syncTokenService: SyncTokenService
    ) {
        this.buildForm();
        this.buildSyncTokenForm();
        this.loginTokenForm.get("token")?.valueChanges.subscribe((value: any) => {
            if (value.length > 8) {
                this.showValidateError = true
            } else {
                this.showValidateError = false
            }
        })
    }

    async ngOnInit(): Promise<void> {
        if (this.notificationsSeen == null || this.notificationsSeen == 'true') {
            sessionStorage.setItem('notificationSeen', 'false')
        }
        await this.preloadTranslations()
        this.accessToken = sessionStorage.getItem(StorageKeysEnum.ACCESS_TOKEN_WSO);
        const userInfo = this.userUtilsService.getUserInfoSessionStorage()
        this.fullName = userInfo?.fullName
        if (this.accessToken != null) {
            const tokenDecodeAsString = sessionStorage.getItem(StorageKeysEnum.JWT_WSO_DECODE);
            const tokenDecode: any = tokenDecodeAsString ? JSON.parse(tokenDecodeAsString) : {}
            this.sitTokenValue = sitToken[tokenDecode.sitToken as keyof typeof sitToken];

        }
        if (this.sitTokenValue == sitToken.OP || this.sitTokenValue == sitToken.AC) {
            this.querySecretWord();
        } else if (this.sitTokenValue == sitToken.BL || this.sitTokenValue == sitToken.BI) {
            this.queryError = true;

        } else {
            this.queryError = true;
        }
    }

    buildForm() {
        this.loginTokenForm = this.formBuilder.group({
            token: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(8)]]
        });
    }

    buildSyncTokenForm() {
        this.syncTokenForm = this.formBuilder.group({
            token1: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(8)]],
            token2: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(8)]]
        })
    }

    SendEmailToUnlockToken() {
        const p = {
            title: this.translations['Desbloquear token'],
            p1: this.tokenUnlockService.internalMsg ? this.translations['Superaste el numero de intentos permitidos'] : this.translations['Para desbloquear tu token'],
            p2: this.translations['Enviamos un codigo de seguridad al correo autorizado en tu contrato'],
            p3: this.translations['Ingresa los 6 digitos'],
        }
        p.title,
            this.tokenUnlockService.openExternalUnlockToken(false, {
                title: p.title,
                paragraph: `
				<p>
					${p.p1}. 
					<strong>${p.p2}.</strong> 
					${p.p3}.
				</p>`,
                translations: this.translations.TOKEN_UNLOCK
            });
    }

    showAuthorizationToCancelToken() {
        this.tokenCancelAuthorizationService.open();
    }

    async preloadTranslations() {
        this.translations = await firstValueFrom(this.translate.get([
            "TOKEN_UNLOCK",
            'Superaste el numero de intentos permitidos',
            'Enviamos un codigo de seguridad al correo autorizado en tu contrato',
            'Ingresa los 6 digitos',
            'Desbloquear token',
            'Para desbloquear tu token',
            'Enviamos un codigo de seguridad al correo autorizado en tu contrato',
        ]))
    }

    async validateToken() {
        let response
        this.loading = true;
        this.showLoginError = false;
        try {
            response = await firstValueFrom(this.authenticationService.validateToken(this.loginTokenForm.getRawValue().token));
            const isTemporalPassword = this.requirePasswordUpdate(response);
            if (isTemporalPassword) {
                this.router.navigate(['/changeTemporalPassword'])
                return;
            }
        } catch (error) {
            console.log(error);
            this.loading = false;
            this.showLoginError = true;
            return
        }

        this.loading = false;

        if (response?.requiereSiguiente == true) {
            this.requiereSiguiente = response.requiereSiguiente;
            return;
        }
        if (response.resultado) {
            this.onValidateTokenSuccess.emit();
        } else if (response.estadoToken == "BL" || response.estadoToken == "BI") {
            this.sitTokenValue = sitToken.BL
            this.queryError = true;
        } else if (response?.estadoToken === 'SYNC_TOKEN') {
            this.showSyncToken = true
            this.sitTokenValue = sitToken.SYNC_TOKEN
            this.queryError = true;
        } else {
            this.showLoginError = true;
        }
    }


    requirePasswordUpdate(validateTokenResponse) {
        const jwtToken = validateTokenResponse.authorizationBanca;
        let isTemporalPassword = false;
        if (jwtToken) {
            const jwtDecoded = jwt.decodeJwt(jwtToken);
            if (jwtDecoded["rcp"] && jwtDecoded["rcp"] === true) {
                isTemporalPassword = true
            }
        }
        return isTemporalPassword;
    }

    querySecretWord() {
        this.queryLoading = true;
        this.authenticationService.querySecret(this.accessToken).subscribe({
            next: value => {
                this.secret = value.secret;
                let userInfo: any = sessionStorage.getItem(StorageKeysEnum.USER_INFO);
                userInfo = userInfo ? JSON.parse(userInfo) : {};
                if(value.imgBytes != null){
                userInfo['userImage'] = 'data:image/png;base64,' + value.imgBytes;
                sessionStorage.setItem(StorageKeysEnum.USER_INFO, JSON.stringify(userInfo))
                }
            },
            error: err => {
                console.log(err);
            }
        });
        this.queryLoading = false;
    }

    async onLogOut() {
        await this.authenticationService.logOut();
        this.onLogout.emit();
    }

    protected readonly sitToken = sitToken;

    closeChangeModalPassword() {
    }

    syncToken() {
        this.loading = true;
        this.showSyncError = false;
        this.loadingSynchronizing = true;
        const syncRequest = this.syncTokenForm.getRawValue();
        this.syncTokenService.synchronizeToken(syncRequest).subscribe({
            next: response => {
                if (response && response.token && response.token != '') {
                    sessionStorage.setItem(StorageKeysEnum.ACCESS_TOKEN_WSO, response.token);
                    this.onValidateTokenSuccess.emit();
                    this.loading = false;
                    this.loadingSynchronizing = false;
                    return;
                } else {
                    this.showSyncError = true;
                    this.loading = false;
                    this.loadingSynchronizing = false;
                }
            },
            error: err => {
                if (err && err.error && err.error.errorCode && err.error.errorCode === 'TOKEN_04') {
                    this.sitTokenValue = sitToken.BL
                    this.queryError = true;
                } else {
                    this.showSyncError = true;
                }
                this.loading = false;
                this.loadingSynchronizing = false;
                return;
            },
            complete: () => {
                this.loading = false;
                this.loadingSynchronizing = false;
            }
        })
    }

    ngAfterViewInit() {
    }


}
